module.exports = "<div class=\"moreRoundCon\" fxLayout=\"column\">\n  <div class=\"moreRoundOptList\" (click)=\"selectMoreOption(opt.name,i,$event);\" *ngFor=\"let opt of moreRoundOption;let i=index\">\n    <div fxFlex=\"20\" fxLayoutAlign=\"center center\">\n      <span [class]=\"opt.icon\"></span>\n    </div>\n    <div fxLayoutAlign=\"start center\">\n      <span>{{opt.name}}</span>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/popups/bookmoreoptions/bookmoreoptions.component.html
// module id = ./src/app/bookShared/popups/bookmoreoptions/bookmoreoptions.component.html
// module chunks = main